<template>
  <div class="patient-reedback">
    <template v-if="showWin">
      <div class="left">
        <userlist ref="userlistRef" @change="handlechange" />
      </div>
      <div class="center">
        <userFeedback
          v-if="activeItem.patientCode"
          :info="activeItem"
          @success="activeItem = {}"
        />
        <empty v-else />
      </div>
      <div class="right">
        <div class="right-title">就诊记录</div>
        <tab2 v-if="activeItem.patientCode" :info="activeItem" />
        <empty v-else />
      </div>
    </template>
    <empty v-else text="暂无权限" />
  </div>
</template>

<script>
import { hasAuth } from "@/utils/uEdition.js";
import userlist from "./com/userlist.vue";
import tab2 from "@/views/treasureChest/successCase/com/tab2.vue";
import userFeedback from "./com/userFeedback.vue";
export default {
  components: {
    userlist,
    tab2,
    userFeedback,
  },
  data() {
    return {
      activeItem: {},
      showWin: false,
    };
  },
  methods: {
    handlechange(item) {
      this.activeItem = item || {};
    },
  },
  created() {
    this.showWin = hasAuth("YZ-12");
  },
};
</script>

<style lang="scss" scoped>
.patient-reedback {
  padding: 15px;
  display: flex;
  height: 100%;
  & > div {
    height: 100%;
    background: #fff;
    border-radius: 5px;
  }
  .left {
    width: 200px;
  }
  .center {
    flex: 1;
    border: 1px solid #eee;
    border-width: 0 1px;
    margin: 0 15px;
    padding: 0 15px;
  }
  .right {
    width: 500px;
    margin-right: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    .right-title {
      font-weight: bold;
      font-size: 15px;
      padding: 5px 0 0;
    }
    :deep {
      .m_r_l_item {
        border-bottom-width: 1px;
        padding: 10px 0;
      }
    }
  }
  .empty {
    width: 100%;
  }
}
</style>

